:host {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-direction: row;
  padding: 0;
  margin: 0;
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
  list-style: none;
}

@media (min-width: 768px) {
  :host {
    padding: 0 calc(var(--space-unit) * 2);
  }
}
